import { AppCategory, AppRecord } from '$tablet-app/src/app/app_library/types';
import FullScreenLoader from '$tablet-app/src/app/components/FullScreenLoader';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { font_variant_styles } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import AppSelectionItem from '../AppSelectionItem';
import AppCategoryChip from '../AppSelectionScreen/AppCategoryChip';

interface Props {
  apps: AppRecord[];

  search_text?: string;

  categories?: AppCategory[];

  category_filters?: string[];

  isLoading?: boolean;

  isRefetching?: boolean;

  onPressApp?: (app: AppRecord) => void;

  onPressUninstall?: (app: AppRecord) => void;

  onChangeSearchText?: (text: string) => void;

  onPressCategoryFilter?: (category?: string) => void;

  refresh?: () => void;
}

const empty_categories: string[] = [];
const empty_category_options: AppCategory[] = [];

const MyApps: FC<Props> = (props) => {
  const {
    apps,
    search_text,
    categories = empty_category_options,
    category_filters = empty_categories,
    isLoading,
    isRefetching,
    onChangeSearchText,
    onPressApp,
    onPressUninstall,
    onPressCategoryFilter,
    refresh,
  } = props;

  return (
    <>
      <InputContainer>
        <InputIconContainer>
          <FontAwesomeIcon icon="search" color="white" size={20} />
        </InputIconContainer>

        <SearchInput
          placeholder="Search apps"
          value={search_text}
          onChangeText={onChangeSearchText}
          placeholderTextColor="rgba(248, 255, 255, 0.9)"
        />
      </InputContainer>

      <Spacer height="24px" />

      <Row width="100%">
        <AppCategoryChip
          active={category_filters.length === 0}
          onPress={onPressCategoryFilter}
        >
          All
        </AppCategoryChip>

        {categories.map((category) => (
          <React.Fragment key={category.value}>
            <Spacer width="12px" />
            <AppCategoryChip
              category={category.value}
              active={category_filters.includes(category.value)}
              onPress={onPressCategoryFilter}
            >
              {category.label}
            </AppCategoryChip>
          </React.Fragment>
        ))}
      </Row>

      {isLoading ? (
        <FullScreenLoader />
      ) : !isLoading && !apps.length ? (
        <Row justifyContent="center" alignItems="center" flex={1}>
          <Text variant="h1">No apps match your search</Text>
        </Row>
      ) : (
        <ScrollList
          onRefresh={refresh}
          refreshing={isRefetching}
          data={apps}
          numColumns={8}
          keyExtractor={(item, index) => item.package_name || index.toString()}
          renderItem={({ item }) => (
            <ItemContainer key={item.label}>
              <AppSelectionItem
                app={item}
                onPress={onPressApp}
                onPressUninstall={onPressUninstall}
              />
            </ItemContainer>
          )}
        />
      )}
    </>
  );
};

const ScrollList = styled.FlatList`
  padding-top: 30px;
`;

const ItemContainer = styled.View`
  width: 150px;
  height: 170px;

  align-items: center;
`;

const InputContainer = styled.View`
  background-color: rgba(248, 255, 255, 0.3);
  flex-direction: row;

  width: 100%;
  border-radius: 15px;
`;

const InputIconContainer = styled.View`
  padding: 20px;
`;

const SearchInput = styled.TextInput`
  ${font_variant_styles.h3.regular}

  color: #F8FFFF;
  flex: 1;
`;

export default MyApps;
